import { Modal } from "@devhop/ui";
import { type ReactNode, useState } from "react";
import { AppImage } from "@/shared/ui/AppImage";

type ImagePreviewModalProps = {
  fileKey: string;
  title?: string;
  triggerClassName?: string;
  children: ReactNode;
};

export function ImagePreviewModal({
  fileKey,
  title = "ເບິ່ງຮູບ",
  triggerClassName,
  children,
}: ImagePreviewModalProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={triggerClassName}
        onClick={() => setOpen(true)}
        aria-label={title}
      >
        {children}
      </button>
      <Modal
        open={open}
        onOpenChange={setOpen}
        title={title}
        size="lg"
        className="max-h-[90vh] max-w-[min(96vw,56rem)]"
      >
        <div className="flex max-h-[min(82vh,900px)] w-full items-center justify-center overflow-auto">
          <AppImage
            src={fileKey}
            alt=""
            className="max-h-[min(82vh,900px)] w-full object-contain"
            showLoading
          />
        </div>
      </Modal>
    </>
  );
}
